export default "__VITE_ASSET__yBHxrRTS__"